export class Relationship {
    prId: string = null;
    prName: string = null;
}